var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBinoculars({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.956 16.706L18.331 4.925C17.976 3.774 16.929 3 15.726 3C14.223 3 13 4.223 13 5.726V7H11V5.726C11 4.223 9.777 3 8.274 3C7.07 3 6.024 3.774 5.669 4.925L2.044 16.706C2.015 16.801 2 16.9 2 17V17.5C2 19.982 4.019 22 6.5 22C8.981 22 11 19.982 11 17.5V13H13V17.5C13 19.982 15.019 22 17.5 22C19.981 22 22 19.982 22 17.5V17C22 16.9 21.985 16.801 21.956 16.706ZM6.5 20C5.122 20 4 18.878 4 17.5C4 16.122 5.122 15 6.5 15C7.878 15 9 16.122 9 17.5C9 18.878 7.878 20 6.5 20ZM9 13.762C8.284 13.282 7.425 13 6.5 13C6.049 13 5.623 13.086 5.212 13.21L7.58 5.512C7.675 5.206 7.954 5 8.274 5C8.674 5 9 5.325 9 5.726V7V13V13.762ZM11 11V9H13V11H11ZM15 7V5.726C15 5.325 15.326 5 15.726 5C16.046 5 16.325 5.206 16.42 5.513L18.788 13.211C18.377 13.086 17.951 13 17.5 13C16.575 13 15.716 13.282 15 13.762V13V7ZM17.5 20C16.122 20 15 18.878 15 17.5C15 16.122 16.122 15 17.5 15C18.878 15 20 16.122 20 17.5C20 18.878 18.878 20 17.5 20Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinoculars);
export default ForwardRef;